import { getBookingDetailDataAction } from "../../../Actions/LogicActions/BookingDetail/GetBookingDetailDataAction";
import { updateActiveKeyForTripSummaryAction } from "../../../Actions/LogicActions/BookingDetail/UpdateActiveKeyForTripSummaryAction";
import { getMultiBookingRefundSummaryAction } from "../../../Actions/LogicActions/MultiBooking/GetMultiBookingRefundSummaryAction";
import { shareTicketAction } from "../../../Actions/UIActions/BookingDetail/ShareTicketAction";
import { unmountBookingDetailAction } from "../../../Actions/UIActions/BookingDetail/UnmountBookingDetailAction";
import { cancelBookingRedirectClickAction } from "../../../Actions/UIActions/CancelBooking/CancelBookingRedirectClickAction";
import { ticketPopupOpenCloseAction } from "../../../Actions/UIActions/TicketDetail/TicketPopupOpenCloseAction";
import { requestInvoicePopupOpenCloseAction } from "../../../Actions/UIActions/TicketDetail/RequestInvoicePopupOpenCloseAction";
import { requestInvoiceSubmitAction } from "../../../Actions/LogicActions/RequestInvoice/RequestInvoiceSubmitAction";
import { upgradeToPremiumAction } from '../../../Actions/LogicActions/UpgradePremium/UpgradeToPremiumAction';
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { cancelBookingTree } from "../../../Orchestrator/ConstantTree/CancelBookingPage/CancelBookingTree";
import { srReqClaimTree } from "../../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IGetBookingDetailsActionParams, IUpdateActiveKeyForTripSummaryActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";
import { IShareTicketParams } from "../../../Orchestrator/Types/Interface/ActionParams/IShareTicketActionParams";
import { IAddShuttleTransferActionParams, IBookingDetailsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";
import { ITicketModalPopupAction } from "../../../Orchestrator/Types/Interface/EventParams/TicketAction";
import { TicketDetailContext } from "../../TicketDetail/Context/TicketDetailContext";
import { passengerTypeAction, stopAction } from "../../../Actions/Index";
import { addShuttleTransferClickAction } from "../../../Actions/UIActions/AddShuttleTransfer/AddShuttleTransferClickAction";
import { confirmMultiBookingCancelAction } from "../../../Actions/UIActions/CancelBooking/ConfirmMultiBookingCancelAction";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";



class BookingDetailStep extends StepFlow {
    get stepName() { return "BookingDetail_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IGetBookingDetailsActionParams, void>({
                eventName: bookingTree.Details.GetBooking.Init,
                handler: async (payload) => {
                    await passengerTypeAction.execute();
                    updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
                    getBookingDetailDataAction.setParams(payload.data!);
                    await getBookingDetailDataAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ITicketModalPopupAction, void>({
                eventName: bookingTree.Ticket.Popup.OpenClose,
                handler: async (payload) => {
                    let context = this.getCtx<TicketDetailContext>("ticketDetailContext")!;
                    context.bookingId = payload.data?.bookingId!
                    ticketPopupOpenCloseAction.setParams(payload.data!);
                    await ticketPopupOpenCloseAction.execute();
                    if (ticketPopupOpenCloseAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        this.next();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: cancelBookingTree.CancelBooking.CancelBookingRedirectClick,
                handler: async (data: any) => {
                    if (typeof window !== "undefined" && window?.location) {
                        const previousRoute = window.location.pathname + (window.location.search || "");
                        data.data.previousRoute = previousRoute;
                    }
                    cancelBookingRedirectClickAction.setParams(data.data!);
                    await cancelBookingRedirectClickAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IBookingDetailsActionParams, void>({
                eventName: bookingTree.Details.srClaim.Click,
                handler: async (payload: any) => {
                    _eventBus.emit({
                        eventName: "FLOW_CLOSE",
                        data: "BookingDetailFlow",
                    });
                    updateRecoilState("lastVisitedPageForServiceRequestAtom", payload?.data?.pathName || "")
                    if (payload.data?.direction != "") {
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: `/service-request-claim/${payload.data?.bookingId}${payload.data?.direction ? `?direction=${payload.data?.direction == TripTypeEnum.IN_BOUND ? 'inbound' : payload.data?.direction == TripTypeEnum.OUT_BOUND ? 'outbound' : ""}` : ""}`,
                        });
                    } else {
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: `/service-request-claim/${payload.data?.bookingId}`,
                        });
                    }

                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookingTree.Details.Help.Click,
                handler: async () => {
                    _eventBus.emit({
                        eventName: "FLOW_CLOSE",
                        data: "BookingDetailFlow",
                    });

                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: "/help",
                    });
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IShareTicketParams, void>({
                eventName: bookingTree.Details.ShareTicket.Click,
                handler: async (payload) => {
                    shareTicketAction.setParams(payload.data!);
                    await shareTicketAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.Details.MultiBookingCancel.Click,
                handler: async ({ data }) => {
                    const booking = data?.booking;
                    if (booking) {
                        getMultiBookingRefundSummaryAction.setParams({ booking });
                        await getMultiBookingRefundSummaryAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.Details.MultiBookingCancel.Confirm,
                handler: async ({ data }) => {
                    confirmMultiBookingCancelAction.setParams({booking: data?.booking || null});
                    await confirmMultiBookingCancelAction.execute();
                    if (isActionRunSuccessfully(confirmMultiBookingCancelAction) && data?.booking?.booking?.id) {
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: `/bookings`
                        });
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookingTree.Details.Unmount,
                handler: async (payload) => {
                    unmountBookingDetailAction.execute()
                }
            })
        );
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.RequestClaim.ClaimDetail,
                handler: async ({ data }) => {
                    _eventBus.emit({
                        eventName: "FLOW_CLOSE",
                        data: "BookingDetailFlow",
                    });
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: `/service-request-details${data ? '?bookingId=' + data : ""}`
                    })
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IUpdateActiveKeyForTripSummaryActionParams, void>({
                eventName: bookingTree.Details.ExpandCollapse,
                handler: async ({ data }) => {
                    updateActiveKeyForTripSummaryAction.setParams(data!);
                    await updateActiveKeyForTripSummaryAction.execute();
                }
            })
        )

        // RequestInvoice event handlers for BookingDetail page
        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.RequestInvoice.Popup.OpenClose,
                handler: async ({ data }) => {
                    if (data) {
                        requestInvoicePopupOpenCloseAction.setParams(data);
                        await requestInvoicePopupOpenCloseAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.RequestInvoice.Popup.Close,
                handler: async ({ data }) => {
                    if (data) {
                        requestInvoicePopupOpenCloseAction.setParams(data);
                        await requestInvoicePopupOpenCloseAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.RequestInvoice.Submit.Click,
                handler: async ({ data }) => {
                    if (data) {
                        requestInvoiceSubmitAction.setParams(data);
                        await requestInvoiceSubmitAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<any, void>({
                eventName: bookingTree.UpgradeToPremium.Click,
                handler: async ({ data }) => {
                    if (data) {
                        upgradeToPremiumAction.setParams({
                            trip: data.trip,
                            bookingId: data.bookingId,
                            upgradeOutboundOffers: data.upgradeOutboundOffers,
                            upgradeInboundOffers: data.upgradeInboundOffers
                        });
                        await upgradeToPremiumAction.execute();
                    }
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on<IAddShuttleTransferActionParams, void>({
                // Unreachable: nothing emits this any more — shuttle add goes through
                // the Manage End-to-end Journey section. Kept with the legacy
                // /bookings/add-shuttle page it routes to, to be removed together.
                eventName: bookingTree.AddShuttleTransfer.Click,
                handler: async (payload) => {
                    addShuttleTransferClickAction.setParams(payload.data!)
                    await addShuttleTransferClickAction.execute();

                    if (addShuttleTransferClickAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        stopAction.execute();
                        _eventBus.emit({
                            eventName: "FLOW_CLOSE",
                            data: "AfterSalesBookingFlow",
                        });
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: `/bookings/add-shuttle/${addShuttleTransferClickAction.result}`,
                        });
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
    }

    // /**
    //      * @method onEventTearDown
    //      * Added this event - when Event Tear Down - Need to update/Reset recoil state
    //     */
    // async onEventTearDown(): Promise<void> {
    //     _eventBus.emit({
    //         eventName: bookingTree.Details.Unmount
    //     })
    // }
}

export const BookingDetailStepDeclaration = new StepDefinition({
    stepName: "BookingDetail_Step",
    stepClass: BookingDetailStep
});